// ToastPortal.jsx
import ReactDOM from 'react-dom';

const ToastPortal = ({ children }) => {
  const portalRoot = document.getElementById('toast-root');
  return portalRoot
    ? ReactDOM.createPortal(
        <div className="fixed top-0 left-0 w-full z-toast ">{children}</div>,
        portalRoot,
      )
    : null;
};

export default ToastPortal;
